export type CatalogV2AddToBagCta = 'add' | 'view' | 'soldOut' | 'hide';

/**
 * Catalog-v2 in-page CTA. Sold out is only honest when MCF (or native
 * inventory) is linked AND the SKU is out of stock. Unlinked SKUs never
 * show Sold out. View requires Link out plus marketplace offers
 * and beats Sold out.
 */
export function resolveCatalogV2AddToBagCta(input: {
  isEligibleForCheckout: boolean;
  whereToBuyFallback: boolean;
  hasMarketplaceOffers: boolean;
  isLinkedToInventory?: boolean;
  isOutOfStock: boolean;
}): CatalogV2AddToBagCta {
  if (input.isEligibleForCheckout) {
    return 'add';
  }
  if (input.whereToBuyFallback && input.hasMarketplaceOffers) {
    return 'view';
  }
  const isLinked = input.isLinkedToInventory !== false;
  if (isLinked && input.isOutOfStock) {
    return 'soldOut';
  }
  return 'hide';
}
